module.exports = __webpack_public_path__ + "static/thumbnail_with_action-ea64226a7e827cd58de7f8fcd426b896.png";